import {
  Box,
  Button,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { Grid } from "@mui/system";

export interface DevObjectDraft {
  /** absent when creating */
  id?: string;
  raw: string;
  mid: string;
  k: string;
  v: string;
}

interface Props {
  draft: DevObjectDraft;
  onChange: (draft: DevObjectDraft) => void;
  onSave: () => void;
  onCancel: () => void;
}

/**
 * Create / edit form for a Dev Objects row. Unlike the report and interface
 * editors, these rows are written immediately - there is no parent to save.
 */
const DevObjectForm = ({ draft, onChange, onSave, onCancel }: Props) => {
  const isValid = !!draft.raw.trim() && !!draft.mid.trim() && !!draft.k.trim();

  return (
    <Paper
      variant="outlined"
      sx={{ p: 2, m: 2, borderColor: "#9C27B0", backgroundColor: "#FBF7FC" }}
    >
      <Typography sx={{ fontSize: "14px", fontWeight: 500, mb: 2 }}>
        {draft.id ? `Edit object ${draft.id}` : "Create new object"}
      </Typography>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 3 }}>
          <TextField
            required
            fullWidth
            size="small"
            label="object_type"
            value={draft.raw}
            onChange={(event) => onChange({ ...draft, raw: event.target.value })}
            color="secondary"
          />
        </Grid>
        <Grid size={{ xs: 12, md: 3 }}>
          <TextField
            required
            fullWidth
            size="small"
            label="object_value"
            value={draft.mid}
            onChange={(event) => onChange({ ...draft, mid: event.target.value })}
            color="secondary"
          />
        </Grid>
        <Grid size={{ xs: 12, md: 3 }}>
          <TextField
            required
            fullWidth
            size="small"
            label="field_type"
            placeholder="e.g. api_request_timeout"
            value={draft.k}
            onChange={(event) => onChange({ ...draft, k: event.target.value })}
            color="secondary"
          />
        </Grid>
        <Grid size={{ xs: 12, md: 3 }}>
          <TextField
            fullWidth
            size="small"
            label="field_value"
            placeholder="plain text or JSON"
            value={draft.v}
            onChange={(event) => onChange({ ...draft, v: event.target.value })}
            color="secondary"
          />
        </Grid>
      </Grid>
      <Stack direction="row" spacing={1} justifyContent="flex-end" sx={{ mt: 2 }}>
        <Box sx={{ flex: 1 }} />
        <Button size="small" color="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          size="small"
          variant="contained"
          color="secondary"
          disabled={!isValid}
          onClick={onSave}
        >
          Save row
        </Button>
      </Stack>
    </Paper>
  );
};

export default DevObjectForm;
